export default __webpack_public_path__ + "static/media/image-set-lego.d1d443ba.png";